module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "sec8"
    }
  }), _vm._v("Words")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Parole. Mote in one’s own eye. The deceit"), _c('br'), _vm._v("That a lifetime is. I wasn’t there"), _c('br'), _vm._v("When something happened. Something")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Happened. A chair was pushed out from a table."), _c('br'), _vm._v("Don’t listen if you don’t want to know"), _c('br'), _vm._v("What happened, the Sergeant said. I don’t want to know")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The future as it’s seen on that inked slip of paper"), _c('br'), _vm._v("That says one has only now and no more."), _c('br'), _vm._v("It was fourth grade or fifth.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Or it was eighth grade or the grade up the side"), _c('br'), _vm._v("Of the river or the ditch at the side of the road."), _c('br'), _vm._v("It was very steep. It’s always been difficult.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Breath like a hollow rasp but almost silent."), _c('br'), _vm._v("A management that keeps one sane. A hand gliding"), _c('br'), _vm._v("An iron over a piece of fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Like skates, like a sewing stitch"), _c('br'), _vm._v("Done to keep one’s attention from wavering."), _c('br'), _vm._v("The self talking to a mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("All the doctors know that. The ones who see you lying"), _c('br'), _vm._v("On a sofa. They know that there is a sound"), _c('br'), _vm._v("In one’s head. They know there is that deep")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Relief from the waking state called sleep. How little else"), _c('br'), _vm._v("They know unless you tell them. I tell them"), _c('br'), _vm._v("I wish I could lie under the summer.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b175b72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1_d.vue
// module id = 96
// module chunks = 0